import * as React from "react";
function SvgFunnelPlus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M32 22h-4v4h-2v-4h-4v-2h4v-4h2v4h4v2zm-.1-19.4c-.2-.4-.5-.6-.9-.6H1c-.4 0-.7.2-.9.6-.2.3-.1.8.1 1.1L12 17.4V29c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V17.4L31.8 3.7c.2-.3.3-.8.1-1.1zM18.2 16.3c-.1.2-.2.5-.2.7v11h-4V17c0-.2-.1-.5-.2-.7L3.2 4h25.7L18.2 16.3z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFunnelPlus);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
